import { Container, Sprite } from 'pixi.js';

import { Shared } from '../../App';

export class BillboardRotator extends Container
{
    private type: string;
    private base: Sprite;
    private icon: Sprite;

    constructor(type: 'ccw' | 'cw' = 'ccw')
    {
        super();
        this.type = type;

        this.base = new Sprite(Shared.assets.getTexture(`rotate-button`));
        this.base.anchor.set(0.5);
        this.addChild(this.base);

        this.icon = new Sprite(Shared.assets.getTexture(`icon-replay`));
        this.icon.anchor.set(0.5);
        this.addChild(this.icon);
        this.icon.scale.x = 1.25;
        if (this.type === 'cw') this.icon.scale.x *= -1;
    }

    public press(): void
    {
        this.base.scale.set(1 * 0.9);
        this.icon.scale.set(1.25 * 0.9, 1.25 * 0.9);
        if (this.type === 'cw') this.icon.scale.x *= -1;
    }

    public release(): void
    {
        this.base.scale.set(1);
        this.icon.scale.set(1.25, 1.25);
        if (this.type === 'cw') this.icon.scale.x *= -1;
    }
}
